import type { ReactNode } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { PwaPushGateChecking, PwaPushGateScreen } from './PwaPushGateScreen';
import { usePushGate } from './usePushGate';

/**
 * Condición para ver la app mobile: tener las notificaciones activadas en este dispositivo (permiso dado y dispositivo
 * activo en el backend). Si no, se ve SOLO la pantalla de activación — sin barra inferior ni campanita.
 * Falla abierto (sin red, sin soporte, impersonando…): ver `pushGate.ts`. Es un bloqueo de UX, no de seguridad.
 */
export function PwaPushGate({ children }: { children: ReactNode }) {
  const { state, working, error, enable, recheck } = usePushGate();
  const { signOut } = useAuth();

  if (state === 'checking') return <PwaPushGateChecking />;
  if (state === 'needs_enable' || state === 'denied') {
    return (
      <PwaPushGateScreen
        variant={state}
        working={working}
        error={error}
        onEnable={enable}
        onRecheck={recheck}
        onSignOut={signOut}
      />
    );
  }
  return <>{children}</>;
}
